import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AsideMenuModule } from '@epicuro-next/ataraxia/aside-menu';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import {
  DynamicComponentsModule,
  ResolveConfigService,
} from '@epicuro-next/platform/dynamic-components';
import { clearPane, selectPanes } from '@epicuro-next/state/user-ui-state';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';

@Component({
  selector: 'epc-side-pane',
  styleUrls: ['./side-pane.scss'],
  templateUrl: './side-pane.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    AsideMenuModule,
    DynamicComponentsModule,
    IconsModule,
  ],
  providers: [ResolveConfigService],
})
export class SidePaneComponent {
  private readonly pane$ = this.store.select(selectPanes).pipe(
    map((panes) => {
      return panes.right;
    }),
  );

  public readonly content$ = this.pane$.pipe(
    map((pane) => {
      return pane.content;
    }),
  );

  public readonly title$ = this.pane$.pipe(
    map((pane) => {
      return pane.title;
    }),
  );

  public readonly showCloseButton$ = this.pane$.pipe(
    map((pane) => {
      return pane.settings?.showCloseButton === true;
    }),
  );

  public readonly opened$ = this.content$.pipe(
    map((content) => {
      return content !== null && content !== undefined && content.length > 0;
    }),
  );

  public readonly backdropClass$ = this.pane$.pipe(
    map((pane) => {
      return pane.settings?.backdropClass;
    }),
  );

  public readonly className$ = this.pane$.pipe(
    map((pane) => {
      return pane.settings?.className;
    }),
  );

  constructor(private readonly store: Store) {}

  public onOpenStateChanged(open: boolean): void {
    this.opened$.pipe(take(1)).subscribe((opened) => {
      if (opened && !open) {
        this.closePane();
      }
    });
  }

  public onCloseClicked(): void {
    this.closePane();
  }

  private closePane(): void {
    this.store.dispatch(
      clearPane({
        location: 'right',
      }),
    );
  }
}
